import Image from 'next/image';
import Link from 'next/link';
import React from 'react';

const OurOfferingAiSecurityGovernance = () => {
    return (
        <div className="section-py !pb-0 dark:bg-black">
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="lg:col-span-10 pb-10">
                        <h2 className="mb-0 dark:text-white" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            Our AI Security & Governance Offerings
                        </h2>
                    </div>
                </div>
                <div className="row grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-2 mb-10">
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid">
                        <div className="voice-generator-box mb-3">
                            <Image src="/img/ai-agent/svg/ic-agent-design.svg" width={36} height={36} alt="Agent design" />
                        </div>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">AI security assessments, vulnerability testing & threat modeling frameworks</p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid">
                        <div className="voice-generator-box mb-3">
                            <Image src="/img/ai-agent/svg/ic-mcp-server.svg" width={36} height={36} alt="MCP server-client setup" />
                        </div>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            AI governance policy development, implementation & enforcement automation
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/ai-agent/svg/ic-multi-agent.svg"
                                width={36}
                                height={36}
                                alt="Multi-agent workflow"
                            />
                        </div>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Data privacy controls, encryption & secure AI data handling pipelines
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/ai-agent/svg/ic-action-validation.svg"
                                width={36}
                                height={36}
                                alt="Action validation"
                            />
                        </div>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Access management, authentication & role-based permissions for AI systems
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/ai-agent/svg/ic-secure-audit.svg"
                                width={36}
                                height={36}
                                alt="Secure audit"
                            />
                        </div>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Model monitoring, bias detection, fairness evaluation, continuous testing
                        </p>
                    </div>
                </div>
                <div className="row grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-2 mb-[50px]">
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/ai-agent/svg/ic-agent-monitoring.svg"
                                width={36}
                                height={36}
                                alt="Agent monitoring"
                            />
                        </div>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Compliance automation for GDPR, HIPAA, SOC 2, and ISO standards
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/ai-agent/svg/ic-agent-accelerators.svg"
                                width={36}
                                height={36}
                                alt="Agent accelerators"
                            />
                        </div>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Audit trail implementation, logging, explainability framework development & prompt injection defense
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid">
                        <div className="voice-generator-box mb-3">
                            <Image src="/img/ai-agent/svg/ic-mcp-protocol.svg" width={36} height={36} alt="MCP protocol" />
                        </div>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                           Model security hardening, container security & secure deployment practices
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/ai-agent/svg/ic-custom-data-indexing.svg"
                                width={36}
                                height={36}
                                alt="Custom data indexing"
                            />
                        </div>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            AI risk assessment frameworks & responsible AI program establishment
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid">
                        <div className="voice-generator-box mb-3">
                            <Image src="/img/ai-agent/svg/ic-hybrid-rpa-ai.svg" width={36} height={36} alt="Hybrid RPA-AI" />
                        </div>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Red teaming exercises, penetration testing for AI-specific vulnerabilities
                        </p>
                    </div>
                </div>
                <div className="row grid lg:grid-cols-12 bg-ready-transform rounded-10 relative">
                    <div className="counter-overlay"></div>
                    <div className="lg:col-span-12 lg:p-12 md:p-5 p-5 relative z-[1]">
                        <h2 className="mb-3 text-white">Ready to Transform Your Enterprise Knowledge into Intelligent Action?</h2>
                        <p className="mb-3 text-white">
                            Request a demo to see production-ready RAG pipelines and enterprise chatbots in action
                        </p>
                        <div>
                            <Link href="/contact-us" className="btn btn-primary">
                                {'Schedule a call with us'}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OurOfferingAiSecurityGovernance;
